
import { TextSectionEntityDecoratorBase } from './text-section.decorator.base';


export class TextSectionEntityDecorator extends TextSectionEntityDecoratorBase {
}



